<template>
  <div v-html="htmlContent"></div>
</template>
<script>

import MarkdownIt from 'markdown-it';
import prism from 'markdown-it-prism';
import 'prismjs/components/prism-python'

export default {
  props: {
    content: String
  },
  computed: {
    htmlContent () {
      const md = new MarkdownIt({html: true});
      md.use(prism);
      const rendered = md.render(this.content)
      if (window.MathJax) {
        window.MathJax.Hub.Config({
          tex2jax: {
            inlineMath: [['$', '$']],
            displayMath: [['$$', '$$']],
            processEscapes: true,
            processEnvironments: true,
          },
          // Center justify equations in code and markdown cells. Elsewhere
          // we use CSS to left justify single line equations in code cells.
          displayAlign: 'center',
          'HTML-CSS': {
            styles: { '.MathJax_Display': { margin: 0 } },
            linebreaks: { automatic: true },
          },
        })
        window.MathJax.Hub.Queue([
          'Typeset',
          window.MathJax.Hub,
          rendered,
        ])
      }
      return rendered
    }
  }
}
</script>